import React, { useEffect } from 'react';

const Product6 = () => {
  const images = [
    "/Novation.png",
    "https://novation-inc.com/wp-content/uploads/2021/02/2A-768x555.jpg",
    "https://novation-inc.com/wp-content/uploads/2021/01/ScrapTracker1-2.jpg",
    "https://novation-inc.com//srv/htdocs/wp-content/uploads/2021/05/slidebasP1.jpg",
    "https://novation-inc.com/wp-content/uploads/2021/03/flagchart2.gif"
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-10 bg-black text-white">
      <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500 animate-slide-in">
        Novation, Inc.
      </h1>

      <div className="space-y-12">
        {/* Company Overview */}
        <section className="flex flex-col items-center text-center space-y-6">
  <h3 className="text-3xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
    Company Overview
  </h3>
  <p className="text-lg leading-relaxed max-w-4xl hover:scale-105 hover:text-gray-200 transition duration-500">
    Since 2002, Novation has been a global leader in safety and waste reduction for printing and converting industries.
    With over 1,500 installations worldwide, our innovative products safely and automatically mark and track defects,
    playing a critical role in process optimization for industries such as flexible packaging, electronics, automotive,
    healthcare, hygiene, and more. All products are proudly manufactured in Bethlehem, PA.
  </p>
  <div className="w-full flex justify-center">
    <div className="w-full max-w-4xl aspect-video">
      <iframe
        className="w-full h-full rounded-lg shadow-lg border-2 border-gray-600"
        src="https://www.youtube.com/embed/dHiX9RbLLTA"
        title="AF3 WebFlagger with Adjustable Side Base"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </div>
</section>
        {/* AF3 WebFlagger */}
        <section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src={images[1]}
              alt="AF3 WebFlagger"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
              AF3 WebFlagger
            </h3>
            <p className="text-lg leading-relaxed hover:scale-105 hover:text-gray-200 transition duration-500">
              Novation’s AF3 WebFlagger applies pressure-sensitive “flags” to webs moving at speeds over 4,000 fpm. It connects to
              inspection systems or machine signals to mark defects precisely when they arrive. Its adhesive-deadened edges prevent
              sticking to machine parts, and optional adjustable bases make it versatile for varying web widths.
            </p>
          </div>
        </section>

        {/* ScrapTracker */}
        <section className="flex flex-col lg:flex-row items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src={images[2]}
              alt="ScrapTracker"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
              ScrapTracker
            </h3>
            <p className="text-lg leading-relaxed hover:scale-105 hover:text-gray-200 transition duration-500">
              ScrapTracker creates detailed roll maps, logging up to six types of defects by associating them with uniquely numbered flags.
              These roll maps enable easy reporting and process review, helping reduce waste, improve efficiency, and integrate with
              downstream processes through Novation’s RollCode system.
            </p>
          </div>
        </section>

        {/* RollCode */}
        <section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src={images[3]}
              alt="RollCode"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
              RollCode
            </h3>
            <p className="text-lg leading-relaxed hover:scale-105 hover:text-gray-200 transition duration-500">
              RollCode automates downstream processes like slitting and roll editing by using ScrapTracker roll maps to stop machines
              at flagged defects. This eliminates the need for manual flag detection, enabling higher speed and efficiency while
              displaying defect details on a touchscreen interface.
            </p>
          </div>
        </section>

        <h3 className="text-3xl font-semibold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500">
            Process of Flag Styling
          </h3>

      {/* Image 4 - Landscape Frame */}
<div className="flex justify-center">
  <img
    src={images[4]}
    alt="Novation System Interface"
    className="rounded-xl shadow-lg w-full max-w-[1124px] object-cover h-[1000px] border-2 border-gray-600"
  />
</div>

        {/* Industries Served - Elaborated */}
        <section className="text-center mt-12">
          <h3 className="text-3xl font-semibold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500">
            Industries We Serve
          </h3>
          <ul className="text-lg space-y-6 text-left mx-auto max-w-5xl hover:text-gray-300 transition-all">
            <li>
              <strong>Flexible Packaging:</strong> Supporting high-speed labeling and defect tracking in film, pouch, and foil production lines.
            </li>
            <li>
              <strong>Electronics and Automotive:</strong> Enhancing quality control in precision electronics and automotive component manufacturing.
            </li>
            <li>
              <strong>Films, Tapes, and Non-Wovens:</strong> Providing real-time defect detection and roll tracking in thin, continuous material processes.
            </li>
            <li>
              <strong>Healthcare & Hygiene Products:</strong> Ensuring defect-free production of sensitive medical-grade and sanitary products.
            </li>
            <li>
              <strong>Label, Printing, and Converting:</strong> Automating defect marking and enabling traceability in high-volume print and label workflows.
            </li>
          </ul>
        </section>

        
        {/* Contact Us Section */}
        <section className="mt-12 text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Contact Us
          </h3>
          <p className="text-lg">
            For more information about our products and services, please contact us at:- 
            <a href="mailto: rambomble@alphaq.co.in" className="text-blue-500 hover:text-blue-700 transition-colors duration-300">
             rambomble@alphaq.co.in
            </a>
          </p>
        </section>


      </div>
    </div>
  );
};

export default Product6;